module.exports = {"attributes":{"width":"11","height":"7","viewBox":"0 0 11 7","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M1.24128 7L5.50036 2.58803 9.75945 7 11 5.69707 5.5 2.36425e-7 -5.69527e-8 5.69707z\" transform=\"rotate(-180 5.5 3.5)\" fill=\"currentColor\" fill-rule=\"evenodd\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
